<template>
  <cumulus-edit-form
    ref="form"
    :icon="icon"
    :title="title"
    :new-item="new_item"
    :help="private_record ? 'flight-general-edit-private' : 'flight-general-edit'"
    @escape="escape"
    @save="save"
    @remove="remove"
  >
    <template v-slot:editform>
      <edit-form
        :flight-general="edited_item"
        :private-record="private_record"
      />
    </template>
  </cumulus-edit-form>
</template>

<script>
  // Utilities
  import { call, get } from 'vuex-pathify'
  import moment from 'moment'

  export default {
    name: 'FlightGeneralEdit',
    components: {
      EditForm: () => import('@/layouts/default/edit/FlightGeneral'),
    },
    data: function () {
      return {
        icon: '$edit',
        title: 'flight_datas',
        edited_item_id: -1,
        edited_item: {
          plane_id: null,
          date: null,
        },
        loading: false,
        prevRoute: '/flight/general',
        saved: false,
        ognLog: [],
      }
    },
    computed: {
      new_item () { return this.edited_item_id === -1 },
      profile: get('auth/profile'),
      private_record () { return this.$route.name === 'Flights/FlightGeneralPrivateEdit' },
    },
    watch: {
      'edited_item.plane_id': {
        handler (newValue, oldValue) {
          // console.log(this.edited_item.plane_id)
          if (parseInt(newValue) !== parseInt(oldValue)) {
            if (this.new_item) {
              this.refreshLastFlight()
            }
          }
        },
      },
      'edited_item.date': {
        handler (newValue, oldValue) {
          console.log('edited_item.date')
          // console.log(this.edited_item.plane_id)
          if (newValue !== oldValue) {
            if (this.new_item && newValue.length === 10) {
              this.refreshLastFlight()
            }
          }
        },
      },
      'edited_item.sic_id': {
        handler () {
          if (!this.edited_item.sic_id) {
            this.edited_item.cost_sharing = 0
          }
        },
        // deep: true,
      },
    },
    mounted () {
      this.fetch()
      console.log(this.$route)
    },
    methods: {
      getLastFlight: call('flightGeneral/getLastFlight'),
      fetchEditedItem: call('flightGeneral/fetch'),
      insertEditedItem: call('flightGeneral/insert'),
      updateEditedItem: call('flightGeneral/update'),
      deleteEditedItem: call('flightGeneral/delete'),
      getLastFlightOgn: call('plane/getLastFlightOgn'),
      async fetch () {
        this.edited_item_id = parseInt(this.$route.params.id)
        this.loading = true
        if (!this.new_item) {
          await this.fetchEditedItem(
            { id: this.edited_item_id },
          ).then(response => {
            this.edited_item = response
            this.loading = false
          })
        } else {
          this.edited_item.plane_id = parseInt(this.$route.params.plane_id)
          this.edited_item.date = this.private_record ? moment(Date.now()).format('YYYY-MM-DD') : ''
          // console.log(this.edited_item.plane_id)
          // this.refreshLastFlight()
        }
      },
      async save () {
        this.loading = true
        if (this.new_item) {
          await this.insertEditedItem(
            this.edited_item,
          ).then(response => {
            this.saved = true
            this.escape()
          }).catch(e => {
            this.loading = false
            this.$refs.form.setErrors(e)
            console.log(e)
          })
        } else {
          await this.updateEditedItem(
            this.edited_item,
          ).then(response => {
            this.saved = true
            this.escape()
          }).catch(e => {
            this.loading = false
            this.$refs.form.setErrors(e)
            console.log(e)
          })
        }
      },
      async remove () {
        this.loading = true
        await this.deleteEditedItem(
          { id: this.edited_item_id },
        ).then(response => {
          this.saved = true
          this.escape()
        }).catch(e => {
          this.loading = false
          this.$refs.form.setErrors(e)
          console.log(e)
        })
      },
      async refreshLastFlight () {
        if (this.edited_item.plane_id === null) {
          return
        }
        console.log('refreshLastFlight')
        console.log(this.edited_item.plane_id)

        const date = this.edited_item.date
        await this.getLastFlight(
          { plane_id: this.edited_item.plane_id },
        ).then(response => {
          this.edited_item = {
            date: date, // this.private_record ? moment(Date.now()).format('YYYY-MM-DD') : '',
            plane_id: parseInt(response.plane_id),
            pic_id: this.private_record ? this.profile.user_id : '',
            takeoff_counter: response.landing_counter,
            takeoff_airport_id: response.landing_airport_id,
            landing_airport_id: response.landing_airport_id,
            takeoff_time: this.edited_item.takeoff_time,
            landing_time: this.edited_item.landing_time,
            takeoff_blocktime: this.edited_item.takeoff_blocktime,
            landing_blocktime: this.edited_item.landing_blocktime,
            landing: 1,
            task_id: 'tsk_03', // response.task_id,
            validation_at: !this.private_record ? moment(Date.now()).format('YYYY-MM-DD HH:mm:ss') : '',
          }
          if (this.private_record && this.new_item) {
            this.getLastFlightOgn({ plane_id: this.edited_item.plane_id, date: this.edited_item.date }).then(response => {
              if (this.edited_item.takeoff_time !== null) {
                this.edited_item.date = response.date
                this.edited_item.takeoff_time = response.takeoff
                this.edited_item.landing_time = response.landing
                this.edited_item.takeoff_blocktime = response.takeoff
                this.edited_item.landing_blocktime = response.landing
                this.edited_item.landing = response.touch_and_go + 1
              }
            })
          }
        }).catch(e => {
          this.edited_item.takeoff_counter = null
        })
      },
      escape () {
        this.$router.push(this.prevRoute).catch(() => {})
      },
    },
  }
</script>
